export default class Venue{
    name;
    latitude;
    longitude;
    image;
}